import React, { useEffect, useState, useRef } from 'react';
import HomeLayout from '../../components/home_page/HomeLayout';
import Form from '../../components/Form/Form';
import MasterListFooter from '../../components/Footer/Master_Footer/MasterListFooter';
import NavFooterLayout from '../../components/NavNameOfComponent/NavFooterLayout';
import { useDropdownKeyboardNavigation } from '../../components/Custom_Hooks/useDropdownKeyboardNavigation';
import { useDropdownScroll } from '../../components/Custom_Hooks/useDropdownScroll';
import BranchCreateModal from './BranchCreateModal';
import DeletConfirm from '../../components/Modal/DeletConfirm';
import { toast } from 'react-toastify';

const initialBranchDataList = [
    { 
        name: "Pachore Road", 
        branch_code: "11", 
        address: "Boda", 
        under: "Main Location", 
        branch_manager: "Kamal Kushwah (Ac No)", 
        mobile: "9617965916", 
        status: "Active",
        allowedBackDated: "Yes",
        cutOffDate: "23-Dec-2025 (Tuesday)",
        mailingName: "Yadav Krishi Sewa Kendra",
        mailingAddress1: "Pachore Road, Near Police Station",
        mailingAddress2: "Boda",
        mailingState: "Madhya Pradesh",
        mailingPincode: "465685",
        mailingMobile: "91 9617965916",
        mailingEmail: "snlyadav11@gmail.com"
    },
    { 
        name: "Pachore", 
        branch_code: "74", 
        address: "Pachore", 
        under: "Primary", 
        branch_manager: "Amar Dubey (Ac No)", 
        mobile: "9617965916", 
        status: "Inactive",
        allowedBackDated: "No",
        cutOffDate: "23-Dec-2025 (Tuesday)",
        mailingName: "Amar Dubey & Sons",
        mailingAddress1: "Main Road",
        mailingAddress2: "Pachore",
        mailingState: "Madhya Pradesh",
        mailingPincode: "465685",
        mailingMobile: "91 9617965916",
        mailingEmail: "amar.dubey@gmail.com"
    }
];

function BranchCreate() {
    const [loading, setLoading] = useState(true);
    const [all_data, setAll_data] = useState([]);
    const [enabled, setEnabled] = useState(true);
    const [isCreateOpen, setIsCreateOpen] = useState(false);
    const [selectedBranch, setSelectedBranch] = useState(null);
    const [isView, setIsView] = useState(false);
    const [isDeleteOpen, setIsDeleteOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const timer = setTimeout(() => {
            setAll_data(initialBranchDataList);
            setLoading(false);
        }, 150);
        return () => clearTimeout(timer);
    }, []);

    const handleOpenAlter = (item) => {
        setSelectedBranch(item);
        setIsView(false);
        setIsCreateOpen(true);
    };

    const handleOpenView = (item) => {
        setSelectedBranch(item);
        setIsView(true);
        setIsCreateOpen(true);
    };

    // Handle Keyboard shortcuts and selection navigation from the table list
    const { selectedItemIndex, setSelectedItemIndex } = useDropdownKeyboardNavigation({
        items: all_data,
        state: !isCreateOpen && !isDeleteOpen,
        initialIndex: 0,
        enableAlphaJump: true,
        getLabel: (item) => item?.name || '',
        onItemAltCSelect: () => {
            setSelectedBranch(null);
            setIsView(false);
            setIsCreateOpen(true);
        },
        onItemSelect: (item) => {
            handleOpenView(item);
        },
        onItemControlEnterSelect: (item) => {
            handleOpenAlter(item);
        },
        onItemAltDSelect: (item) => {
            setIsDeleteOpen(true);
        }
    });

    useDropdownScroll({ dropdownRef, selectedItemIndex });

    // Handle successful creation or alteration of branch
    const handleBranchCreated = (newBranchData) => {
        if (selectedBranch) {
            // Alter/Edit mode
            setAll_data(prev => prev.map(item => item.branch_code === selectedBranch.branch_code ? newBranchData : item));
        } else {
            // Create mode
            setAll_data(prev => [...prev, newBranchData]);
        }
    };

    const handleDeleteSubmit = (e) => {
        if (e) e.preventDefault();
        const branchToDelete = all_data[selectedItemIndex];
        if (branchToDelete) {
            setAll_data(prev => prev.filter(item => item.branch_code !== branchToDelete.branch_code));
            toast.success("Branch deleted successfully!", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 1500
            });
        }
        setIsDeleteOpen(false);
    };

    // Custom layout click handler for mouse users clicking in the footer
    useEffect(() => {
        const handleFooterClick = (e) => {
            const buttonElement = e.target.closest('button');
            if (buttonElement) {
                if (buttonElement.textContent.includes('Create Master') && !isCreateOpen) {
                    setSelectedBranch(null);
                    setIsView(false);
                    setIsCreateOpen(true);
                } else if (buttonElement.textContent.includes('Delete') && !isCreateOpen && !isDeleteOpen) {
                    setIsDeleteOpen(true);
                } else if (buttonElement.textContent.includes('Alter') && !isCreateOpen) {
                    if (all_data[selectedItemIndex]) {
                        handleOpenAlter(all_data[selectedItemIndex]);
                    }
                }
            }
        };
        document.addEventListener('click', handleFooterClick);
        return () => document.removeEventListener('click', handleFooterClick);
    }, [isCreateOpen, isDeleteOpen, all_data, selectedItemIndex]);

    return (
        <HomeLayout>
            {isCreateOpen && (
                <div style={{ zIndex: 10000 }}>
                    <BranchCreateModal
                        closeModal_sec={() => {
                            setIsCreateOpen(false);
                            setSelectedBranch(null);
                            setIsView(false);
                        }}
                        onSuccess={handleBranchCreated}
                        editData={selectedBranch}
                        viewOnly={isView}
                    />
                </div>
            )}
            <Form
                title='Branch Management'
                col='col-12'
                loading={loading}
                Footer={MasterListFooter}
                createMasterEnabled={enabled}
                deleteEnabled={true}
            >
                {isDeleteOpen && (
                    <div style={{ zIndex: 10000 }}>
                        <DeletConfirm
                            handleSubmit={handleDeleteSubmit}
                            loading={false}
                            closeModal={() => setIsDeleteOpen(false)}
                        />
                    </div>
                )}
                <div className="row p-0 m-0 border_2_1px_top border_2_2px_bottom mt-0">
                    <div
                        className="col-1 font_size p-0 m-0 px-1 text-end fw-bold"
                        style={{ width: "5%" }}
                    >
                        Sr No.
                    </div>
                    <div
                        className="col-3 font_size p-0 m-0 px-1 text-start fw-bold"
                        style={{ width: "25%" }}
                    >
                        Branch Name
                    </div>
                    <div
                        className="col-1 font_size m-0 p-0 px-1 text-end fw-bold"
                        style={{ width: "10%" }}
                    >
                        Branch Code
                    </div>
                    <div
                        className="col-2 font_size m-0 p-0 px-1 text-start fw-bold"
                        style={{ width: "13%" }}
                    >
                        Address
                    </div>
                    <div
                        className="col-2 font_size m-0 p-0 px-1 text-start fw-bold"
                        style={{ width: "12%" }}
                    >
                        Under
                    </div>
                    <div
                        className="col-2 font_size m-0 p-0 px-1 text-start fw-bold"
                        style={{ width: "15%" }}
                    >
                        Branch Manager
                    </div>
                    <div
                        className="col-1 font_size m-0 p-0 px-1 text-end fw-bold"
                        style={{ width: "12%" }}
                    >
                        Mobile
                    </div>
                    <div
                        className="col-1 font_size p-0 m-0 px-1 text-start fw-bold"
                        style={{ width: "8%" }}
                    >
                        Branch Status
                    </div>
                </div>
                <div className='row gx-0 p-0 mb-2' style={{ overflowY: 'hidden' }}>
                    <div className='col m-0 p-0' ref={dropdownRef} style={{ overflowY: 'auto', height: '75.3vh' }}>
                        {
                            all_data.map((item, index) => {
                                return (
                                    <div
                                        key={index}
                                        onClick={() => setSelectedItemIndex(index)}
                                        onDoubleClick={() => handleOpenAlter(item)}
                                        style={{ cursor: "pointer" }}
                                        className={`row gx-0 p-0 m-0 mt-0 ${index === selectedItemIndex ? "selected" : ""}`}
                                    >
                                        <div
                                            className="col-1 font_size p-0 m-0 px-1 text-end"
                                            style={{ width: "5%" }}
                                        >
                                            {index + 1}
                                        </div>
                                        <div
                                            className="col-3 font_size p-0 m-0 px-1 text-start"
                                            style={{ width: "25%" }}
                                        >
                                            {item?.name}
                                        </div>
                                        <div
                                            className="col-1 font_size m-0 p-0 px-1 text-end"
                                            style={{ width: "10%" }}
                                        >
                                            {item?.branch_code}
                                        </div>
                                        <div
                                            className="col-2 font_size m-0 p-0 px-1 text-start"
                                            style={{ width: "13%" }}
                                        >
                                            {item?.address}
                                        </div>
                                        <div
                                            className="col-2 font_size m-0 p-0 px-1 text-start"
                                            style={{ width: "12%" }}
                                        >
                                            {item?.under}
                                        </div>
                                        <div
                                            className="col-2 font_size m-0 p-0 px-1 text-start"
                                            style={{ width: "15%" }}
                                        >
                                            {item?.branch_manager ? item.branch_manager.split(' (')[0] : ''}
                                        </div>
                                        <div
                                            className="col-1 font_size m-0 p-0 px-1 text-end"
                                            style={{ width: "12%" }}
                                        >
                                            {item?.mobile}
                                        </div>
                                        <div
                                            className="col-1 font_size p-0 m-0 px-1 text-start fw-bold"
                                            style={{
                                                width: "8%",
                                                color: item?.status === 'Active' ? '#198754' : '#dc3545'
                                            }}
                                        >
                                            {item?.status}
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                <NavFooterLayout>
                    <b className='ps-2'> {all_data.length} Branch(es)</b>
                </NavFooterLayout>
            </Form>
        </HomeLayout>
    )
}

export default BranchCreate;
